import { set } from 'cerebral/operators';
import { state } from 'cerebral/tags';

export default [
    set(state`app.firstTime`, false),
];



// WEBPACK FOOTER //
// ./src/store/modules/app/signals/triggerFirstTime.js